import { call, restService } from './apiHelpers';

const multipart = (payload) => {
  const form = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) form.append(key, value);
  });
  return form;
};

export const vehicleService = {
  ...restService('vehicles'),
  getForActor: (_, filters) => call('get', 'vehicles/', null, filters),
  getDetailForActor: (id) => call('get', `vehicles/${id}/`),
  getFormOptions: (_, coordinatorId) =>
    call('get', 'vehicles/form-options/', null, { coordinador_id: coordinatorId }),
  createForActor: (payload) => call('post', 'vehicles/', multipart(payload)),
  updateForActor: (id, payload) => call('patch', `vehicles/${id}/`, multipart(payload)),
  getReviewSummary: () => call('get', 'vehicles/review-summary/'),
  review: (id, decision, note) =>
    call('post', `vehicles/${id}/review/`, { decision, note }),
  changeDriver: (id, driverId) =>
    call('post', `vehicles/${id}/change-driver/`, { driver_id: driverId }),
  changeStatus: (id, status) =>
    call('post', `vehicles/${id}/change-status/`, { status }),
};
